import { Controller } from 'stimulus';

// The Mark complete sheet: as Done on changes, asks the server
// (MaintenanceCompletionsController#preview) for the next due date and the
// on time or late wording; says what a changed equipment status will do.
export default class extends Controller {
  static targets = ['date', 'timing', 'next', 'nextDue', 'status', 'statusHint']

  connect() {
    this.preview();
  }

  preview() {
    const value = this.dateTarget.value;
    if (!value) return;

    const params = new URLSearchParams({ done_on: value.slice(0, 10), due_on: this.data.get('dueOn') || '' });
    fetch(`${this.data.get('previewUrl')}?${params}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data) return;
        this.timingTarget.textContent = data.timing || '';
        this.timingTarget.classList.toggle('mc-late', Boolean(data.late));
        this.nextTarget.hidden = !data.next_due;
        if (data.next_due) this.nextDueTarget.textContent = data.next_due;
      });
  }

  statusChanged() {
    const kept = this.statusTarget.value === this.data.get('status');
    this.statusHintTarget.textContent = kept
      ? 'Unchanged. Pick Up if the work brought it back.'
      : `The equipment will be ${this.statusTarget.value} from then.`;
  }
}
